import React, { Component } from 'react';
import { connect } from 'react-redux';
import logoImage from 'assets/images/AmrutCup.png';

class UserInfo extends Component {

  state = {
    isShowingUserMenu: false
  };

  render() {
    let { user } = this.props;
    return (
      <div className="user-wrapper">
        <div className="user">
         <a href='/'> <img src={logoImage} alt={user.name} className="photo" /> </a>
          <div className="userinfo">
            <div className="username">
              {user.name}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.Auth.user
});

export default connect(mapStateToProps)(UserInfo);


// WEBPACK FOOTER //
// ./src/components/SideBar/UserInfo.js